"use strict";
import { isExtension } from "utilities/src/platform";
export const getVersionHeader = () => {
  if (isExtension) {
    return process.env.VERSION ?? "";
  } else {
    return "";
  }
};
